import { groupBy } from 'lodash-es';
import { SearchResult } from '@mhe/reader/models';
import { BasicSearchResultGroup, SearchResultGroup } from 'src/app/models/search/search-material.model';

export function searchResultsForMaterial(
  results: SearchResult[],
): BasicSearchResultGroup[] | SearchResultGroup[] {
  // limit of 1000 results, this is the same line as the `map-search-bonsai-tree.ts` file
  results = results.slice(0, 1000);

  // only results in a chapter
  const titledResults = results.filter((r) => r.sectionName !== undefined);

  if (titledResults.length) {
    // formatted for use with Material Expansion Panel bindings
    const groupedResults: SearchResultGroup[] = Object.entries(groupBy(titledResults, (r) => r.sectionName || null))
      .map(([name, results]: [string, SearchResult[]]) => ({
        name,
        expanded: false,
        untitled: false,
        results,
      }));

    // first chapter is expanded by default
    if (groupedResults[0]) {
      groupedResults[0].expanded = true;
    }

    return groupedResults;
  }

  return [
    {
      untitled: true,
      results: results.filter((r) => r.sectionName === undefined),
    },
  ] as BasicSearchResultGroup[];
}
